/**
 * Block: Featured Resources
 */

class FeaturedResources {
	constructor(el) {
		this.el = el;
		this.tabs = '';
		this.tabContent = '';
		this.currentCounter = '';
		this.selectedTab = '';
	}

	setTab() {
		this.tabs = this.el.querySelectorAll('.em-featured-resources__content-section--tab-item');
	}

	setTabContent() {
		this.tabContent = this.el.querySelectorAll('.em-featured-resources__content-section--resources');
	}

	/**
	 * Captured selected tab.
	 */
	selected() {
		for (let i = 0; i < this.tabs.length; i++) {
			const tab = this.tabs[i];
			if (tab.dataset.selected === 'true') {
				this.selectedTab = tab.dataset.counter;
				break;
			}
		}
	}

	/**
	 * Clear data-selected attribute for incoming update.
	 */
	clearSelectedTabAttributes() {
		// Clear tabs.
		this.tabs.forEach((tab) => {
			if (tab.dataset.selected === 'true') {
				tab.setAttribute('data-selected', 'false');
			}
		});
		// Clear tab content.
		this.tabContent.forEach((content) => {
			if (content.dataset.selected === 'true') {
				content.setAttribute('data-selected', 'false');
			}
		});
	}

	/**
	 * Handles switching of tab content.
	 */
	switchContentTab() {
		this.tabContent.forEach((content) => {
			if (content.dataset.counter === this.currentCounter) {
				content.setAttribute('data-selected', 'true');
			}
		});
	}

	init() {
		this.setTab();
		this.setTabContent();
		this.selected();

		this.tabs.forEach((tab) => {
			tab.addEventListener('click', (e) => {
				const selectedTab = e.target.closest('.em-featured-resources__content-section--tab-item');

				if (this.currentCounter !== selectedTab.dataset.counter) {
					this.currentCounter = selectedTab.dataset.counter;
					this.clearSelectedTabAttributes();
					selectedTab.setAttribute('data-selected', 'true');

					this.switchContentTab();
				}
			});
		});
	}
}

const featuredResources = {
	init() {
		const featuredResourceBlock = document.querySelectorAll('.em-featured-resources');

		if (featuredResourceBlock.length) {
			featuredResourceBlock.forEach((block) => {
				const fr = new FeaturedResources(block);
				fr.init();
			});
		}
	},
};

featuredResources.init();
